// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loggin-heading[data-v-68503990]{background:radial-gradient(100% 2844.44% at 0 50%,#2e76e4 0,#6c4dbb 100%);justify-content:center}@media screen and (max-width:768px){.loggin-heading[data-v-68503990]{padding:10px}.loggin-heading svg[data-v-68503990]{width:100%;max-width:300px;height:auto}}", ""]);
// Exports
module.exports = exports;
